import React from 'react'

const Cooperation = () => {
  return (
    <section id='cooperation'>
      <div className="container brd-white bg-white top-none p-5 bg-pic-1">
        <h2 className='title-intro c-dark'>PARTNERSHIP<br />OPPORTUNITIES</h2>
        <div className="s-20"></div>
        <div className="row">
          <div className="col-lg-4">
          </div>
          <div className="col-lg-8">
            <h4 className="title my-4 c-medium">White-Label Development Services</h4>
            <div className="s-10"></div>
            <p className='c-medium'>We provide comprehensive white-label blockchain and software development services, allowing you to deliver projects under your own brand. Our experienced team works seamlessly as an extension of your company, maintaining your brand identity throughout the entire development process.</p>
            <h4 className="title my-4 c-medium">Flexible Partnership Models</h4>
            <div className="s-10"></div>
            <p className='c-medium'>Whether you need dedicated development teams, project-based collaboration, or ongoing technical support, we adapt to your business model. Scale your capacity during peak demands while maintaining quality and confidentiality. Perfect for agencies, consultancies, and businesses looking to expand their service offerings.</p>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </div>
    </section>
  )
}

export {Cooperation}
